module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.disabledCls,
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('input', {
    ref: "input",
    class: _vm.sizeCls,
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "blur": function($event) {
        return _vm.onBlur($event.target)
      },
      "input": function($event) {
        return _vm.updateValue($event.target)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ba9b264","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/libs/ui/input/vInput.vue
// module id = 632
// module chunks = 128